
import React from 'react'
import serialize from 'form-serialize'
import Box from './Box'

/**
 * Form component.
 */

export default Form

/**
 * Expose components.
 */

Form.Row = Row
Form.Actions = Actions

/**
 * Form component.
 */

function Form({ children, reset, onSubmit, ...props }) {
  function submit(e) {
    const values = serialize(e.target, { hash: true })
    const button = e.target.querySelector('button:focus')
    if (button) values[button.name] = button.value
    e.preventDefault()
    if (reset) e.target.reset()
    onSubmit(values)
  }

  return <Box is="form" flex onSubmit={submit} {...props}>
    {children}
  </Box>
}

/**
 * Row is a row of form inputs.
 */

function Row({ children, ...props }) {
  return <Box className="FormRow" {...props}>
    {children}
  </Box>
}


/**
 * Actions is a row of actions.
 */

function Actions({ children, ...props }) {
  return <Box className="FormActions" {...props}>
    {children}
  </Box>
}
